import React, { Component, Fragment } from 'react';
import axios from 'axios';
import FoodItem from './FoodItem';

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: false,
      drinks: [],
      appetizers: [],
      entrees: [],
    };
  }

  componentDidMount() {
    const cockpit_base = `${process.env.REACT_APP_COCKPIT_URL}/cockpit/api/collections/get/`;
    const cockpit_token = process.env.REACT_APP_COCKPIT_TOKEN;
    // console.log('before Promise - this.state: ', this.state);
    Promise.all([
      axios.get(`${cockpit_base}drinks?token=${cockpit_token}`),
      axios.get(`${cockpit_base}appetizers?token=${cockpit_token}`),
      axios.get(`${cockpit_base}entrees?token=${cockpit_token}`),
    ])
    // use arrow function to avoid loosing context
    // BTW you don't need to use axios.spread with ES2015 destructuring
      .then(([drinksResponse, appetizersResponse, entreesResponse]) => {
        this.setState({
          drinks: drinksResponse.data,
          appetizers: appetizersResponse.data,
          entrees: entreesResponse.data,
          isLoaded: true,
        });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({ error });
      });
  }

  renderFoods(foods) {
    const foodItems = [];
    for (let i = 0; i < foods.length; i++) {
      foodItems.push(<FoodItem item={foods[i]} key={foods[i]._id} />);
    }
    return foodItems;
  }

  render() {
    return (
      <Fragment>
        <section className="menu">
          <h2>Menu</h2>
          {/* Appetizers */}
          {(this.state.appetizers.entries.length > 0) && (
          <Fragment>
            <h3>Appetizers</h3>
            <div id="appetizers" className="food-blocks-wrapper">
              {this.renderFoods(this.state.appetizers.entries)}
            </div>
          </Fragment>
          )}
          {/* Entrees */}
          {(this.state.entrees.entries.length > 0) && (
          <Fragment>
            <h3>Entrees</h3>
            <div id="entrees" className="food-blocks-wrapper">
              {this.renderFoods(this.state.entrees.entries)}
            </div>
          </Fragment>
          )}
          {/* Drinks */}
          {(this.state.drinks.entries.length > 0) && (
          <Fragment>
            <h3>Drinks</h3>
            <div id="drinks" className="food-blocks-wrapper">
              {this.renderFoods(this.state.drinks.entries)}
            </div>
          </Fragment>
          )}
        </section>
      </Fragment>
    );
  }
}

export default Menu;
